/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormAssignmentAnswer } from './FormAssignmentAnswer';
export type FormAssignmentDetail = {
    status: FormAssignmentDetail.status;
    assignedAt: string;
    expiresAt?: string | null;
    reminderAt?: string | null;
    reminderSentAt?: string | null;
    completedAt?: string | null;
    /**
     * Fill URL when the assignment is still open
     */
    linkUrl?: string | null;
    id: number;
    clientId: number;
    clientFirstName: string;
    clientLastName: string;
    formId: number | null;
    formName: string;
    answers: Array<FormAssignmentAnswer>;
};
export namespace FormAssignmentDetail {
    export enum status {
        OPEN = 'open',
        COMPLETED = 'completed',
        EXPIRED = 'expired',
    }
}

